module.exports = __webpack_public_path__ + "login_bg.57cbd3dcc51a45f08ac0.jpg";


//////////////////
// WEBPACK FOOTER
// E:/MyDemo/Angular2-Demo/Angular-admin/src/assets/img/login_bg.jpg
// module id = ../../../../../src/assets/img/login_bg.jpg
// module chunks = styles